var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "flex", staticStyle: { height: "100%", width: "100%" } },
    [
      _c("div", { staticClass: "leftDiv flex" }, [
        _c("div", { staticClass: "schoolRank" }, [
          _c(
            "div",
            { staticClass: "tableBody" },
            _vm._l(_vm.list, function (item, indexs) {
              return _c(
                "div",
                {
                  key: indexs,
                  staticClass: "ysList",
                  style: { height: item.src != "" ? "1.34rem" : "0.4rem" },
                  on: {
                    click: function ($event) {
                      return _vm.videoClick(item, indexs)
                    },
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "videoDiv flex",
                      class: item.src != "" ? "videoNav" : "wzNav",
                    },
                    [
                      item.src != ""
                        ? _c(
                            "div",
                            { staticStyle: { height: "85%", width: "90%" } },
                            [
                              _c("div", { staticClass: "topTitle" }, [
                                _vm._m(0, true),
                                _c("div", { staticClass: "circle" }, [
                                  _c("div", { staticClass: "circle_x" }, [
                                    _c(
                                      "div",
                                      { staticClass: "circle_zj num flex" },
                                      [_vm._v(" " + _vm._s(indexs + 1) + " ")]
                                    ),
                                    _c("img", {
                                      staticClass: "arround",
                                      attrs: {
                                        src: require("images/video/circle.png"),
                                      },
                                    }),
                                  ]),
                                ]),
                              ]),
                              _c("div", { staticClass: "botTitle" }, [
                                _c("img", {
                                  directives: [
                                    {
                                      name: "lazy",
                                      rawName: "v-lazy",
                                      value: item.src,
                                      expression: "item.src",
                                    },
                                  ],
                                  staticStyle: {
                                    width: "calc(100% - 3px)",
                                    height: "calc(100% - 3px)",
                                    border: "1.5px solid #077EA3",
                                  },
                                }),
                              ]),
                            ]
                          )
                        : _vm._e(),
                      _c(
                        "div",
                        {
                          staticClass: "sp_wz",
                          style: {
                            color: _vm.xzIndex == indexs ? "#fff" : "#ccc",
                          },
                        },
                        [_vm._v(" " + _vm._s(item.name) + " ")]
                      ),
                    ]
                  ),
                  _c("div", {
                    class: _vm.xzIndex == indexs ? "cover" : "cover1",
                  }),
                ]
              )
            }),
            0
          ),
        ]),
      ]),
      _c("div", { staticClass: "rightDiv" }, [
        _c("div", { staticClass: "contMain" }, [
          _c("div", { staticClass: "topRight flex" }, [
            _c("div", { staticClass: "titleName" }, [_vm._v(_vm._s(_vm.name))]),
            _vm._m(1),
            _c(
              "div",
              { staticClass: "titleImg flex", on: { click: _vm.djClick } },
              [
                _c("img", {
                  attrs: { src: require("images/video/icon-fd.png") },
                }),
              ]
            ),
          ]),
          _c("div", { staticClass: "botRight" }, [
            _vm.version
              ? _c("video", {
                  staticStyle: { width: "100%", height: "100%" },
                  attrs: { id: "video", controls: "", autoplay: "" },
                })
              : _c("img", {
                  staticClass: "play-btn",
                  attrs: { src: "img/play-btn.png", alt: "" },
                  on: { click: _vm.toPlay },
                }),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "xcTop flex" }, [
      _c("span", { staticStyle: { "margin-left": "13px" } }, [
        _vm._v("视频机"),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "titleLine" }, [
      _c("img", { attrs: { src: require("images/video/title-line.png") } }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }